import { makeStyles } from '@material-ui/core/styles';

// Mirrors the offer discount row (offer/.../discount + card-line): a full-width line with the
// label on the left and the add/remove affordance on the right, separated by a hairline rule.
export default makeStyles((theme) => ({
  row: {
    alignItems: 'center',
    borderTop: `solid 1px ${theme.colorPalette.beige_25_op_30}`,
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(4)
  },
  inactive: {
    backgroundColor: theme.colorPalette.green_100
  },
  labelSection: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '65%'
  },
  section: {
    display: 'flex',
    alignItems: 'center'
  },
  addButton: {
    boxShadow: 'none'
  },
  statusText: {
    marginRight: theme.spacing(2)
  },
  // Matches the offer discount row's edit affordance.
  editButton: {
    height: 24,
    width: 24,
    padding: 0,
    marginRight: theme.spacing(2)
  },
  editIcon: {
    height: 24,
    width: 24
  }
}));
